import { IconCheck, IconClose } from '@tvg/fuse-icons';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import { Colours } from '../../fuse-colours/src/colours';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';
import { backgroundConfig, customFontSizeConfig, paddingConfig } from './config';

const defineHeadingSize = (size) => {
	const fontSize = `var(--font-size-${size.toLowerCase()})`;
	const lineHeight = `var(--font-line-height-${size.toLowerCase()})`;
	const marginBottom = `var(--spacing-paragraph-margin-bottom-${size.toLowerCase()})`;

	return `font-size: ${fontSize};
            line-height: ${lineHeight};
            margin-bottom: ${marginBottom};`;
};

const StyledTextBlock = styled.div`
	${({ background, paddingTop, paddingBottom, paddingLeft, paddingRight, blackBorder }) => {
		const viewportHeadingSizes = (sizes) =>
			Object.keys(sizes)
				.map(
					(viewport) => `@media screen and (min-width: ${gridConfig[viewport].minWidth}) {
                ${defineHeadingSize(sizes[viewport])}
            }`,
				)
				.join('');

		return `
		&& {
			padding-top: ${!background && !paddingTop && !blackBorder ? '0' : paddingConfig.paddingY.xxs};
			padding-bottom: ${!background && !paddingBottom && !blackBorder ? '0' : paddingConfig.paddingY.xxs};
			padding-left: ${!background && !paddingLeft && !blackBorder ? '0' : paddingConfig.paddingX.xxs};
			padding-right: ${!background && !paddingRight && !blackBorder ? '0' : paddingConfig.paddingX.xxs};

			@media screen and (min-width: ${gridConfig.m.minWidth}) {
				padding-top: ${!background && !paddingTop && !blackBorder ? '0' : paddingConfig.paddingY.m};
				padding-bottom: ${!background && !paddingBottom && !blackBorder ? '0' : paddingConfig.paddingY.m};
				padding-left: ${!background && !paddingLeft && !blackBorder ? '0' : paddingConfig.paddingX.m};
				padding-right: ${!background && !paddingRight && !blackBorder ? '0' : paddingConfig.paddingX.m};
			}

			@media screen and (min-width: ${gridConfig.l.minWidth}) {
				padding-top: ${!background && !paddingTop && !blackBorder ? '0' : paddingConfig.paddingY.l};
				padding-bottom: ${!background && !paddingBottom && !blackBorder ? '0' : paddingConfig.paddingY.l};
				padding-left: ${!background && !paddingLeft && !blackBorder ? '0' : paddingConfig.paddingX.l};
				padding-right: ${!background && !paddingRight && !blackBorder ? '0' : paddingConfig.paddingX.l};
			}

      background-color: ${backgroundConfig.background[background] || 'initial'};
      color: ${backgroundConfig.foreground[background] || 'inherit'};

box-shadow:
	${
	!background && blackBorder
		? 'inset 0 0 0 var(--border-width-m) var(--color-global-black)'
		: 'none'
};

            h1,h2,h3,h4,h5,h6 {
                color: ${backgroundConfig.foreground[background] || 'var(--color-font-heading)'};
                font-weight: var(--font-weight-heading);
            }

			h1:not(.fuse-text-block__custom-text-size), span[class^="fuse-text-block__text-size-6"] { ${viewportHeadingSizes(
		customFontSizeConfig.size6,
	)};}
            h2:not(.fuse-text-block__custom-text-size), span[class^="fuse-text-block__text-size-5"] { ${viewportHeadingSizes(
		customFontSizeConfig.size5,
	)};}
            h3:not(.fuse-text-block__custom-text-size), span[class^="fuse-text-block__text-size-4"] { ${viewportHeadingSizes(
		customFontSizeConfig.size4,
	)};}
            h4:not(.fuse-text-block__custom-text-size), span[class^="fuse-text-block__text-size-3"] { ${viewportHeadingSizes(
		customFontSizeConfig.size3,
	)};}
            h5:not(.fuse-text-block__custom-text-size), span[class^="fuse-text-block__text-size-2"] { ${viewportHeadingSizes(
		customFontSizeConfig.size2,
	)};}
            h6:not(.fuse-text-block__custom-text-size), span[class^="fuse-text-block__text-size-1"] { ${viewportHeadingSizes(
		customFontSizeConfig.size1,
	)};}

		span[class^="fuse-text-block__text-size-"] {display: block;}

		span[class$="-brand-mid"] { color: ${
	backgroundConfig.foreground[background] || 'var(--color-brand-mid)'
};}
		span[class$="-brand-mid"] { color: ${
	backgroundConfig.foreground[background] || 'var(--color-brand-mid)'
};}

      p:not(.fuse-text-block__custom-text-size), ol > li:only-child, ul > li:only-child {
          font-size: var(--font-size-1);
          line-height: var(--font-line-height-1);
          margin-bottom: var(--spacing-paragraph-margin-bottom-1);
          font-weight: var(--font-weight-paragraph);
      }

			.fuse-text-block__text-size-small-p, .fuse-text-block__text-size-small-p-brand-mid {
				font-size: var(--font-size-m2);
				font-weight: var(--font-weight-paragraph);
				line-height: var(--font-line-height-m3);
				margin-bottom: var(--spacing-paragraph-margin-bottom-1);
			}

			.fuse-text-block--p12 {
				font-size: var(--font-size-m2);
				font-weight: var(--font-weight-paragraph);
				line-height: var(--font-line-height-m3);
				margin-bottom: var(--spacing-paragraph-margin-bottom-1);
			}

			.fuse-text-block__text-size-subheading, .fuse-text-block__text-size-subheading-brand-mid {
				font-size: var(--font-size-1);
				font-weight: var(--font-weight-heading);
				line-height: var(--font-line-height-1);
				margin-bottom: var(--spacing-paragraph-margin-bottom-1);
			}

            strong, strong .fuse-text-block__text-size-small-p, strong .fuse-text-block__text-size-small-p-brand-mid  {
                font-weight: var(--font-weight-heading);
            }

						a {
							word-break: break-word;
						}

            a:not(.fuse-styled-link) {
							color: ${backgroundConfig.foreground[background] || 'var(--color-base-black)'};


							&:active,
							&:focus {
									outline: 2px solid ${Colours.functional.focus};
							}

							&:visited {
									color: ${backgroundConfig.foreground[background] || 'var(--color-global-grey800)'};
							}

                &:visited:hover,
                &:visited:focus,
                &:hover,
                &:focus {
                    color: ${backgroundConfig.anchorHover[background] || 'var(--color-brand-dark)'};
                }

                &:active,
                &:visited:active {
                    color: ${backgroundConfig.foreground[background] || 'var(--color-base-black)'};
                }
            }

            ul { list-style-type: disc; padding: 0 0 0 var(--spacing-global-space6); }

            /* List Marker */
            ul li::marker, ol li:before { font-size: var(--font-size-1); }

            /* List Increments */
            ol > li {
                counter-increment: first-counter;
                display: grid;
                grid-template-columns: auto 1fr;
            }
            ol > li:before { content: counter(first-counter) ". "; grid-column: 1; grid-row: 1; padding-right: 6px; line-height: var(--font-line-height-1);}
            ol > li > * { grid-column: 2; }

            ol ol > li { counter-increment: second-counter; }
            ol ol > li:before { content: counter(first-counter) "." counter(second-counter) ". "; }

            ol ol ol > li { counter-increment: roman-counter; }
            ol ol ol > li:before { content: counter(roman-counter,lower-roman) ". "; }

						ul.fuse-text-block__unordered-list--brand-mid>li::marker { color: ${backgroundConfig.foreground[background] || 'var(--color-brand-mid)'}; }

							ul.fuse-text-block__unordered-ticklist--tick > li, ul.fuse-text-block__unordered-crosslist--cross > li {
								list-style-type: none;
								position: relative;
						}

						ul.fuse-text-block__unordered-ticklist--tick > li::before, 
						ul.fuse-text-block__unordered-crosslist--cross > li::before {
								content: '';
								mask-repeat: no-repeat;
								position: absolute;
								left: -2.8rem;
								top: 0;
								width: var(--spacing-global-space6);
								height: var(--spacing-global-space6);
						}

					ul.fuse-text-block__unordered-ticklist--tick > li::before {
								mask-image: ${background ? 'none' : `url('data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(<IconCheck />))}')`};
								background-color: ${background ? 'transparent' : 'var(--color-functional-successMid)'};
								mask-size: contain;
						}

						ul.fuse-text-block__unordered-crosslist--cross > li::before {
								mask-image:  ${background ? 'none' : `url('data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(<IconClose />))}')`};
								background-color: ${background ? 'transparent' : 'var(--color-functional-errorMid)'};
						}
						ul.fuse-text-block__unordered-ticklist--tick > li, ul.fuse-text-block__unordered-crosslist--cross > li {
						list-style-type: ${background ? 'disc' : 'none'};
						position: relative;
						}
								.fuse-text-block__unordered-ticklist--tick .visually-hidden,
								.fuse-text-block__unordered-crosslist--cross .visually-hidden {
										position: absolute;
										width: 1px;
										height: 1px;
										margin: -1px;
										padding: 0;
										overflow: hidden;
										clip: rect(0, 0, 0, 0);
										border: 0;
										white-space: nowrap;
								}


            hr {
				border-top-width: var(--border-width-xs);
                border-bottom-width: 0;
                color: var(--color-functional-divider);
				margin: var(--spacing-global-space7) 0;
            }

            .fuse-text-block--left-align { text-align: left; }
            .fuse-text-block--center-align { text-align: center; }
            .fuse-text-block--foreground-text-brand-mid { color: ${backgroundConfig.foreground[background] || 'var(--color-brand-mid)'};
					}

			&& {
				> *:last-child,
				> *:last-child span[class^="fuse-text-block__text-size-"],
				> *:last-child strong span[class^="fuse-text-block__text-size-"] {
					margin-bottom: 0;
				}
			}
		`;
	}}
`;

export default StyledTextBlock;
